
/**
 * Cache DOM selectors
 */
var $root = document.querySelector('html');
var $header = $root.querySelector('header');
var $wrapper = $root.querySelector('main');
var $navToggle = $header.querySelector('.nav-toggle');
var $navToggleMobile = $root.querySelector('.nav-toggle-mobile');
var $navWrapper = $header.querySelector('.nav');
var $navWrapperMobile = $root.querySelector('.navigation-wrapper-mobile');
var $masonry = $root.querySelector('.section-masonry');
var $overlay = $root.querySelector('.section-overlay');
var $cookieAccept = $root.querySelector('.cookie-accept');
var $toplink = $root.querySelector('.toplink');
var $googleMaps = $root.querySelectorAll('.google-map');
var $vimeoOverview = $root.querySelectorAll('.vimeo-overview');

/**
 * Configuration
 */
var config = {
	overlayFadeoutTime: 5000
};

/**
 * Event: Window pageshow
 */

window.addEventListener('pageshow', function () {

	// Show wrapper once page is loaded
	$wrapper.classList.add('loaded');

	// Call baguetteBox fancybox
	if (!$masonry) {
		baguetteBox.run('main', {
			'noScrollbars': true
		});
	}

	// Show overlay if no cookie is set
	if ($overlay && readCookie('overlay') !== 'true') {
		$overlay.classList.remove('hidden');
	}

	// Set cookie if overlay is clicked
	if ($overlay) {
		$cookieAccept.addEventListener('click', function () {
			writeCookie('overlay', 'true', 3);
			$overlay.classList.add('hidden');
		});
	}

	// Toggle navs
	toggleNav($navToggle, $navWrapper, 'open', '', '');
	toggleNav($navToggleMobile, $navWrapperMobile, 'pushed', $header, $wrapper);

	// Call Packery
	var masonry = '';
	if ($masonry) {
		masonry = new Packery($masonry, {
			itemSelector: '.section-element',
			gutter: 0,
			percentPosition: true,
			transitionDuration: 0
		});
	}

	// Call lazy loading
	var lazy = new LazyLoad({
		elements_selector: '.lazy-image-wrapper img',
		callback_load: function callback_load($elem) {
			$elem.parentNode.classList.add('loaded');

			if ($masonry) {
				masonry.layout();
			}
		}
	});

	// Call animation on Video Overview elements
	if ($vimeoOverview) {
		$vimeoOverview.forEach(function (item) {
			item.querySelector('iframe').addEventListener('load', function () {
				item.classList.add('loaded');
			});
		});
	}

	// Call fitvids
	fitvids('.video-wrapper');

	// Add smooth scrolling to top
	$toplink.addEventListener('click', smoothscroll);
	$toplink.addEventListener('touchstart', smoothscroll);

	showTopLink();

	// Load styled google map if there is any
	if ($googleMaps) {
		$googleMaps.forEach(function (item) {
			initMap(item.id, item.dataset.title, item.dataset.lat, item.dataset.lng);
		});
	}
});

/**
 * Event: Window scroll
 */

window.addEventListener('scroll', function () {

	showTopLink();
});

/**
 * Functions
 */

// Toggle nav
function toggleNav($navToggle, $navWrapper, $toggleClass, $toggleElement1, $toggleElement2) {

	// Toggle nav classes
	$navToggle.addEventListener('click', function () {
		if (!$navToggle.classList.contains($toggleClass)) {
			$navToggle.classList.add($toggleClass);
			if ($toggleElement1) {
				$navWrapper.classList.add($toggleClass);
				$toggleElement1.classList.add($toggleClass);
				$toggleElement2.classList.add($toggleClass);
			} else {
				$navWrapper.classList.add($toggleClass);
			}
		} else {
			$navToggle.classList.remove($toggleClass);
			if ($toggleElement1) {
				$navWrapper.classList.remove($toggleClass);
				$toggleElement1.classList.remove($toggleClass);
				$toggleElement2.classList.remove($toggleClass);
			} else {
				$navWrapper.classList.remove($toggleClass);
			}
		}
	});

	// Close nav when clicking anywhere but the nav
	$root.addEventListener('click', function () {
		if ($navToggle.classList.contains($toggleClass)) {
			$navToggle.classList.remove($toggleClass);
			if ($toggleElement1) {
				$navWrapper.classList.remove($toggleClass);
				$toggleElement1.classList.remove($toggleClass);
				$toggleElement2.classList.remove($toggleClass);
			} else {
				$navWrapper.classList.remove($toggleClass);
			}
		}
	});
	$navToggle.addEventListener('click', function (e) {
		e.stopPropagation();
	});
	$navWrapper.addEventListener('click', function (e) {
		e.stopPropagation();
	});
}

// Show toplink
function showTopLink() {

	if (window.pageYOffset > $header.clientHeight) {
		$toplink.classList.add('visible');
	} else {
		$toplink.classList.remove('visible');
	}
}

// Smooth scrolling to top
function smoothscroll() {
	var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
	if (currentScroll > 0) {
		window.requestAnimationFrame(smoothscroll);
		window.scrollTo(0, currentScroll - currentScroll / 5);
	}
}

// Cookie functions
function writeCookie(name, value, days) {
	var date = void 0,
	    expires = void 0;
	if (days) {
		date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toGMTString();
	} else {
		expires = '';
	}
	document.cookie = name + '=' + value + expires + '; path=/';
}

function readCookie(name) {
	var i = void 0,
	    c = void 0,
	    ca = void 0,
	    nameEQ = name + '=';
	ca = document.cookie.split(';');
	for (i = 0; i < ca.length; i++) {
		c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) === 0) {
			return c.substring(nameEQ.length, c.length);
		}
	}
	return '';
}

// Styled Google maps function
function initMap($elem, title, lat, lng) {

	// Basic options for a simple Google Map
	// For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
	var mapOptions = {
		// How zoomed in you want the map to start at (always required)
		zoom: 16.9,

		// The latitude and longitude to center the map (always required)
		center: new google.maps.LatLng(lat, lng),

		// Map style
		styles: [{ 'featureType': 'administrative', 'elementType': 'all', 'stylers': [{ 'saturation': '-100' }] }, { 'featureType': 'administrative.province', 'elementType': 'all', 'stylers': [{ 'visibility': 'off' }] }, { 'featureType': 'landscape', 'elementType': 'all', 'stylers': [{ 'saturation': -100 }, { 'lightness': 65 }, { 'visibility': 'on' }] }, { 'featureType': 'poi', 'elementType': 'all', 'stylers': [{ 'saturation': -100 }, { 'lightness': '50' }, { 'visibility': 'simplified' }] }, { 'featureType': 'road', 'elementType': 'all', 'stylers': [{ 'saturation': '-100' }] }, { 'featureType': 'road.highway', 'elementType': 'all', 'stylers': [{ 'visibility': 'simplified' }] }, { 'featureType': 'road.arterial', 'elementType': 'all', 'stylers': [{ 'lightness': '30' }] }, { 'featureType': 'road.local', 'elementType': 'all', 'stylers': [{ 'lightness': '40' }] }, { 'featureType': 'road.local', 'elementType': 'geometry.stroke', 'stylers': [{ 'lightness': '-10' }, { 'gamma': '1.00' }] }, { 'featureType': 'transit', 'elementType': 'all', 'stylers': [{ 'saturation': -100 }, { 'visibility': 'simplified' }] }, { 'featureType': 'water', 'elementType': 'geometry', 'stylers': [{ 'hue': '#ffff00' }, { 'lightness': -25 }, { 'saturation': -97 }] }, { 'featureType': 'water', 'elementType': 'geometry.fill', 'stylers': [{ 'color': '#00caf2' }, { 'lightness': '75' }] }, { 'featureType': 'water', 'elementType': 'labels', 'stylers': [{ 'lightness': -25 }, { 'saturation': -100 }] }]
	};

	// Get the HTML DOM element that will contain your map
	// We are using a div with id='map' seen below in the <body>
	var mapElement = document.getElementById($elem);

	// Create the Google Map using our element and options defined above
	var map = new google.maps.Map(mapElement, mapOptions);

	// Let's also add a marker while we're at it
	var marker = new google.maps.Marker({
		position: new google.maps.LatLng(lat, lng),
		map: map,
		title: title
	});
}